export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      
    },
    {
      title: true,
      name: 'Cadastros',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Usuários',
      url: '/usuarios',
      icon: 'icon-user'
    },
    {
      name: 'Pesagem',
      url: '/pesagem',
      icon: 'icon-speedometer'
    }, 
    {
      name: 'Ultimas Pesagens',
      url: '/pesagens',
      icon: 'icon-speedometer'
    }, 
    {
      name: 'Fechamentos',
      url: '/fechamentos',
      icon: 'icon-speedometer'
    }, 
    {
      name: 'Relatórios',
      url: '/relatorios',
      icon: 'icon-chart',
      children: [
        {
          name: 'Geral',
          url: '/relatorios/geral',
          icon: 'icon-puzzle'
        }
      ],
    },
    {
      name: 'Balanças',
      url: '/configuracoes',
      icon: 'icon-wrench'
    },
    
  ]
}